// extracted by mini-css-extract-plugin
module.exports = {"bubble":"_3yecL","content":"xeyLV","triangleWrapper":"il8Ux","arrowleft":"_1la3d","triangle":"wB9Q3"};